const isnot = (a, b) => a !== b;
export default isnot;
